(ns common.schema.entities.esign-process.permissions
  (:require
   [common.schema.entities.permission-checks :as permission-checks]))

(defn read-permissions?
  [ctx]
  (permission-checks/esign-process-read-check-fn ctx))

(defn disable-permissions?
  [ctx]
  (permission-checks/delete-not-allowed! ctx))
